import React from 'react';
import { Link } from 'react-router-dom';
import { VERSION } from '../version';
import { useUserPermissions } from '../hooks/useUserPermissions.jsx';

export function AdminDashboard({ user }) {
  const { userGroups } = useUserPermissions(user);
  const hasAdminAccess = userGroups.includes('adminAccess');
  const hasCatalogAuthor = userGroups.includes('catalogAuthor');

  return (
    <div>
      <h1 className="text-xl font-bold text-orange-400 mb-1">Admin Dashboard</h1>
      <p className="text-gray-400 mb-6">Administration tools for the configurator.</p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {hasAdminAccess && (
          <Link
            to="/admin/audit"
            className="block p-4 rounded border border-gray-800 bg-gray-900 hover:border-orange-400 transition"
          >
            <h2 className="font-bold text-white mb-1">Audit Log</h2>
            <p className="text-sm text-gray-400">
              Fleet-wide quote_generate and config_save events, with filters and pagination.
            </p>
          </Link>
        )}

        {hasAdminAccess && (
          <Link
            to="/admin/users"
            className="block p-4 rounded border border-gray-800 bg-gray-900 hover:border-orange-400 transition"
          >
            <h2 className="font-bold text-white mb-1">Users &amp; Roles</h2>
            <p className="text-sm text-gray-400">
              Current Cognito userbase and the groups each user belongs to.
            </p>
          </Link>
        )}

        {hasAdminAccess && (
          <Link
            to="/admin/account-execs"
            className="block p-4 rounded border border-gray-800 bg-gray-900 hover:border-orange-400 transition"
          >
            <h2 className="font-bold text-white mb-1">Account Executives</h2>
            <p className="text-sm text-gray-400">
              Add, edit, or remove the names reps pick from in the quote&apos;s Account Executive field.
            </p>
          </Link>
        )}

        {hasCatalogAuthor && (
          <Link
            to="/admin/catalog"
            className="block p-4 rounded border border-gray-800 bg-gray-900 hover:border-orange-400 transition"
          >
            <h2 className="font-bold text-white mb-1">Catalog</h2>
            <p className="text-sm text-gray-400">
              Browse the offered product catalog, edit vendor part costs by quarter, or import a
              spreadsheet of updates.
            </p>
          </Link>
        )}
      </div>

      <p className="text-xs text-gray-600 mt-8">v{VERSION}</p>
    </div>
  );
}

export default AdminDashboard;
